export const WEB_ROUTES = {
  HOME: `/`,
  ABOUT: `/about`,
  LEADERSHIP: `/leadership`,
  PROJECT: `/project`,
  IMPACT: `/impact`,
  NEWS: `/news`,
  FEATURED_IN: `/featured-in`,
  GALLERY: `/gallery`,
  CAREERS: `/careers`,
  CONTACT: `/contact-us`,
  NEWSLETTER: `/mailing-list`,
  LEGAL: `/legal`,
  TERMS: `/legal/terms-of-use`,
  PRIVACY_POLICY: `/legal/privacy-policy`,
  CONFLICT_POLICY: `/legal/conflict-of-interest-policy/`,
  COOKIE_POLICY: `/legal/cookie-policy`,
  COPYRIGHT_STATEMENT: `/legal/copyright-statement`,
  CORPORATE_POLICIES: `/policies/corporate-policies`,
  NOT_FOUND: `/404`,
};
